import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  statusColumnContainer: {
    height: 25,
  },
}));
